const ArrowRightDown = ({
  className = "",
  color,
}: {
  className?: string;
  color: string;
}) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    aria-labelledby="title"
    aria-describedby="desc"
    role="img"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      data-name="layer1"
      d="M25.004 48a3 3 0 1 1 0-6h12.752l-20.87-20.87a3 3 0 0 1 4.243-4.243L42 37.76V25.2a3 3 0 0 1 6 0V48z"
      fill={color}
    ></path>
  </svg>
);

export default ArrowRightDown;
